import axios from 'axios'
import config from 'config/app.config'

/**
 * Service to fetch all banners directly using axios
 * @param {object} [params] - Optional query parameters
 * @returns {Promise<Array>} - Returns array of banners or []
 */
export const getAllBannersService = async (params = {}) => {
  const url = `${config.apiGateways.BASE_URL_1}/banners/all`

  try {
    const response = await axios.get(url, {
      params,
      headers: {
        // Add custom headers here if needed, e.g.:
        // Authorization: `Bearer ${token}`,
      },
    })

    // console.log('[BannerService] Response received:', response)

    return response?.data?.result?.rows || []
  } catch (error) {
    // console.error('[BannerService] Error occurred:', error)
    throw error
  }
}
